import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HasItems } from '../types';
import { LocationChangelog, LocationChangelogGroup } from '../types/location-changelog';

@Injectable({
  providedIn: 'root',
})
export class LocationChangelogsService {
  private httpClient = inject(HttpClient);
  readonly apiHost = `${environment.apiBaseUrl}`;

  getLocationChangelogs(branchId: number, locationId: number): Observable<HasItems<LocationChangelog>> {
    const requestUrl = `${this.apiHost}/Branches/${branchId}/Locations/${locationId}/Changelogs`;
    return this.httpClient.get<HasItems<LocationChangelog>>(requestUrl);
  }

  getBranchLocationChangelogs(branchId: number): Observable<HasItems<LocationChangelogGroup>> {
    const requestUrl = `${this.apiHost}/Branches/${branchId}/Locations/Changelogs`;
    return this.httpClient.get<HasItems<LocationChangelogGroup>>(requestUrl);
  }
}
